import { z } from "zod";

export const zSsoUrl = z.object({
  externalAuthUrl: z.string(),
});

export type ZSsoUrl = z.infer<typeof zSsoUrl>;
